import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type SaveWorkflowRuleDefinitionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.WorkflowRuleDefinitionInput;
}>;

export type SaveWorkflowRuleDefinitionMutationResult = { __typename?: 'Mutation' } & {
  saveWorkflowRuleDefinition?: GraphQLTypes.Maybe<
    { __typename?: 'SaveWorkflowRuleDefinitionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
      workflowRuleDefinition?: GraphQLTypes.Maybe<
        { __typename?: 'WorkflowRuleDefinitionType' } & Pick<
          GraphQLTypes.WorkflowRuleDefinitionType,
          'id' | 'ruleDefinitionTag' | 'ruleDescription' | 'ruleName'
        > & {
            ruleInputFields: Array<
              { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'component' | 'label' | 'name'>
            >;
            ruleOutputFields: Array<
              { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'component' | 'label' | 'name'>
            >;
          }
      >;
    }
  >;
};

export const SaveWorkflowRuleDefinitionDocument = /*#__PURE__*/ gql`
  mutation saveWorkflowRuleDefinition($input: WorkflowRuleDefinitionInput!) {
    saveWorkflowRuleDefinition(input: $input) {
      errors {
        message
        path
      }
      workflowRuleDefinition {
        id
        ruleDefinitionTag
        ruleDescription
        ruleInputFields {
          component
          label
          name
        }
        ruleName
        ruleOutputFields {
          component
          label
          name
        }
      }
    }
  }
`;

/**
 * __useSaveWorkflowRuleDefinitionMutation__
 *
 * To run a mutation, you first call `useSaveWorkflowRuleDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkflowRuleDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkflowRuleDefinitionMutation, { data, loading, error }] = useSaveWorkflowRuleDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveWorkflowRuleDefinitionMutation(
  baseOptions?: Apollo.MutationHookOptions<SaveWorkflowRuleDefinitionMutationResult, SaveWorkflowRuleDefinitionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<SaveWorkflowRuleDefinitionMutationResult, SaveWorkflowRuleDefinitionMutationVariables>(
    SaveWorkflowRuleDefinitionDocument,
    options
  );
}
export type SaveWorkflowRuleDefinitionMutationHookResult = ReturnType<typeof useSaveWorkflowRuleDefinitionMutation>;
